import { ArrowDownward, ArrowUpward, StarOutline } from '@mui/icons-material';
import {
  Avatar,
  Button,
  LinearProgress,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import React, { memo, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import EditToken from '../../../screens/editToken';
import {
  convertToInternationalCurrencySystem,
  getFormattedTime,
  logoWrapper,
  toCurrentTerms
} from '../../../utils';
import MiniCandles from '../../MiniCandles/MiniCandles';
import { headerConstants } from './token.table.constants';
import EditDerivativesToken from '../../../screens/editForms/EditDerivativesToken';
import EditSyntheticToken from '../../../screens/editForms/EditSyntheticToken';
import EditStablecoinToken from '../../../screens/editForms/EditStablecoinToken';
import EditWrapToken from '../../../screens/editForms/EditWrapToken';
import EditDCNToken from '../../../screens/editForms/EditDCNToken';
import EditDBTToken from '../../../screens/editForms/editDBTToken';
import EditVentureToken from '../../../screens/editForms/EditVentureToken';
import ErrorBoundary from '../../ErrorBoundary';
// const RedSwapBtn = {
//   display: 'flex',
//   width: '119px',
//   height: '36px',
//   padding: '10px 19px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   gap: '10px',
//   borderRadius: '30px',
//   border: '1px solid #F93C3C',
//   flexShrink: 0,
//   color: '#F93C3C',
//   textAlign: 'center',
//   fontFamily: 'Poppins',
//   fontSize: '16px',
//   fontStyle: 'normal',
//   fontWeight: 500,
//   lineHeight: '100%',
//   marginTop: '-20px'
// };
// const NormalSwapBtn = {
//   display: 'flex',
//   width: '119px',
//   height: '36px',
//   padding: '10px 19px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   gap: '10px',
//   borderRadius: '30px',
//   border: '1px solid #34D399',
//   flexShrink: 0,
//   color: '#34D399',
//   textAlign: 'center',
//   fontFamily: 'Poppins',
//   fontSize: '16px',
//   fontStyle: 'normal',
//   fontWeight: 500,
//   lineHeight: '100%',
//   marginTop: '-20px'
// };

// Per-row Order Book Depth lookup.
//
// /wallet/platform-stats keys byMarket by the symbol orders are stored under.
// For most token types that is already the identitySymbol (hBTC, USXM, ...),
// but EquiTrack orders are booked under the raw ticker ("AAPL"), not the
// listed identitySymbol ("xAAPL") - so the EquiTrack OBD column read N/A for
// every row even though each market had real depth. EquiTrack falls back to
// the raw symbol; other tables don't, so e.g. a wrap whose symbol is "BTC"
// can't accidentally pick up the BTC/USD book.
function obdFor(orderBookDepth, row, href) {
  if (!orderBookDepth || !row) return null;
  const direct = orderBookDepth[row.identitySymbol];
  if (Number.isFinite(direct)) return direct;
  if (href === 'equitrackToken') {
    const raw = orderBookDepth[row.symbol];
    if (Number.isFinite(raw)) return raw;
  }
  return null;
}

function TokenTable({
  loading,
  token,
  blinkUpList,
  blinkDownList,
  href,
  swappable,
  getFormattedTime,
  showPecu,
  priceData,
  pecuBlinkUp,
  pecuBlinkDown,
  volumes
}) {
  // Read only the slices we need — avoids re-rendering on unrelated state changes
  const PecuPrice = useSelector((state) => state.PecuPrice);
  const isAdmin = useSelector((state) => state.isAdmin);
  const { trendHourly, trend, coinVolume, tvl, orderBookDepth } = useSelector(
    (state) => state.stats,
    shallowEqual
  );

  const [priceDown, setPriceDown] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);

  return (
    <TableContainer
      sx={{
        backgroundColor: 'rgba(4, 10, 8, 0.72)',
        mt: 2,
        borderRadius: '0.5rem',
        minHeight: '80vh'
      }}
      component={Paper}
    >
      {loading && <LinearProgress color="inherit" />}
      {!loading ? (
        <Table
          sx={{
            [`& .${tableCellClasses.root}`]: {
              borderBottom: ' 1px solid #142420'
            }
          }}
        >
          <TableHead>
            <TableRow>
              {headerConstants.tableCellNamings.map((header, index) => {
                return (
                  <TableCell style={{ color: 'white' }} key={index}>
                    {header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {showPecu && (
              <TableRow
                className={
                  pecuBlinkUp ? 'blinkup' : pecuBlinkDown ? 'blinkdown' : ''
                }
              >
                <TableCell
                  style={{ color: 'grey', display: 'flex' }}
                  align="left"
                >
                  <StarOutline fontSize="small" />
                </TableCell>
                <TableCell className="twhite" align="left">
                  <Link
                    to={`/Pecu`}
                    state={{
                      price: PecuPrice,
                      symbol: 'PECU'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <Avatar
                        className="rounded"
                        src={`https://dev.hootdex.org/hootdex/images/pecuCoin.png`}
                        alt="token logo"
                        style={{
                          height: '35px',
                          width: '35px',
                          fontSize: '18px'
                        }}
                      />

                      <span
                        style={{
                          marginLeft: '1rem',
                          fontSize: '14px',
                          color: 'grey',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        {' '}
                        <small
                          style={{
                            fontSize: '13px',
                            color: 'white'
                          }}
                        >
                          {'PECU'}
                        </small>
                        <small
                          style={{
                            fontSize: '14px',
                            marginRight: '4px',
                            fontWeight: 400
                          }}
                        >{`${'Pecu Novus'}`}</small>
                      </span>
                    </div>
                  </Link>
                </TableCell>
                <TableCell className={'twhite grey'} align="left">
                  {' '}
                  {PecuPrice}
                </TableCell>
                <TableCell
                  className={
                    trendHourly.trend == '1' ? `twhite green` : `twhite red`
                  }
                  align="left"
                >
                  {trendHourly.trend == '1' ? (
                    <ArrowUpward sx={{ fontSize: '13px' }} />
                  ) : trendHourly.trend == '-1' ? (
                    <ArrowDownward sx={{ fontSize: '13px' }} />
                  ) : (
                    <ArrowUpward sx={{ fontSize: '13px' }} />
                  )}
                  {parseFloat(trendHourly.value).toFixed(4)}%
                </TableCell>
                <TableCell
                  className={trend.trend == '1' ? `twhite green` : `twhite red`}
                  align="left"
                >
                  {trend.trend == '1' ? (
                    <ArrowUpward sx={{ fontSize: '13px' }} />
                  ) : trend.trend == '-1' ? (
                    <ArrowDownward sx={{ fontSize: '13px' }} />
                  ) : (
                    <ArrowUpward sx={{ fontSize: '13px' }} />
                  )}
                  {parseFloat(trend.value).toFixed(4)}%
                </TableCell>

                <TableCell className="twhite grey" align="left">
                  <span>
                    {' '}
                    {convertToInternationalCurrencySystem(
                      coinVolume * PecuPrice
                    )}
                  </span>
                </TableCell>
                <TableCell className="twhite grey" align="left">
                  {' '}
                  {convertToInternationalCurrencySystem(tvl)}
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'grey'
                  }}
                >
                  <p style={{ fontSize: '12px', fontWeight: 300 }}>
                    {new Date()
                      .toUTCString()
                      ?.split(' ')
                      ?.slice(0, 4)
                      .join(' ')}
                  </p>
                  <p style={{ fontSize: '12px', fontWeight: 300 }}>
                    {new Date()?.toUTCString()?.split(' ')[4]} GMT
                  </p>
                </TableCell>
                <TableCell>
                  {' '}
                  <MiniCandles symbol="PECU" chartSymbol="PECU" />
                </TableCell>
              </TableRow>
            )}

            {token?.map((each, index) => {
              const currentPrice =
                Number(
                  priceData && priceData[each.identitySymbol]
                    ? priceData[each.identitySymbol]
                    : each.currentPrice || each.price
                ) || 0;
              return (
                <TableRow
                  key={each.rowKey || each.id}
                  className={
                    blinkUpList.includes(each.identitySymbol)
                      ? 'blinkup'
                      : blinkDownList.includes(each.identitySymbol)
                      ? 'blinkdown'
                      : ''
                  }
                >
                  <TableCell
                    style={{ color: 'grey', display: 'flex' }}
                    align="left"
                  >
                    <StarOutline fontSize="small" />
                  </TableCell>

                  <TableCell style={{ color: 'grey' }} align="left">
                    <Link
                      // A row may carry its own route (the VentureTokens
                      // listing mixes project and holding tokens, which
                      // have different detail pages).
                      to={`/${each.href || href}/${encodeURIComponent(
                        each.identitySymbol || each.symbol || each.token_symbol
                      )}`}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Avatar
                          className="rounded"
                          src={logoWrapper(each?.logo || each.image, each)}
                          alt={each.symbol?.slice(1) || each.token_symbol}
                          style={{
                            height: '35px',
                            width: '35px',
                            fontSize: '18px'
                          }}
                        />
                        <span
                          style={{
                            marginLeft: '1rem',
                            fontSize: '14px',
                            color: 'grey',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          {' '}
                          <small style={{ fontSize: '13px', color: 'white' }}>
                            {each.identitySymbol ||
                              each.symbol ||
                              each.token_symbol}
                          </small>
                          <small
                            style={{
                              fontSize: '14px',
                              marginRight: '4px',
                              fontWeight: 400
                            }}
                          >
                            {toCurrentTerms(each.name || each.token_name)}
                          </small>
                        </span>
                      </div>
                    </Link>
                  </TableCell>

                  <TableCell style={{ color: 'grey' }} align="left">
                    {' '}
                    {currentPrice >= 1
                      ? currentPrice?.toFixed(5).toLocaleString('en-US')
                      : currentPrice?.toFixed(5)}
                  </TableCell>
                  <TableCell
                    className={
                      currentPrice - each.price1hour >= 0
                        ? `twhite green`
                        : `twhite red`
                    }
                    align="left"
                  >
                    {currentPrice - each.price1hour > 0 ? (
                      <ArrowUpward sx={{ fontSize: '13px' }} />
                    ) : currentPrice - each.price1hour < 0 ? (
                      <ArrowDownward sx={{ fontSize: '13px' }} />
                    ) : (
                      <ArrowUpward sx={{ fontSize: '13px' }} />
                    )}
                    {(
                      Math.abs(
                        (currentPrice - each.price1hour) /
                          (each.price1hour || currentPrice)
                      ) * 100
                    )
                      .toFixed(4)
                      .toLocaleString('en-US')}
                    %
                  </TableCell>

                  <TableCell
                    className={
                      currentPrice - each.price24hour >= 0
                        ? `twhite green`
                        : `twhite red`
                    }
                    align="left"
                  >
                    {currentPrice - each.price24hour > 0 ? (
                      <ArrowUpward sx={{ fontSize: '13px' }} />
                    ) : currentPrice - each.price24hour < 0 ? (
                      <ArrowDownward sx={{ fontSize: '13px' }} />
                    ) : (
                      <ArrowUpward sx={{ fontSize: '13px' }} />
                    )}
                    {(
                      Math.abs(
                        (currentPrice - each.price24hour) /
                          (each.price24hour || currentPrice)
                      ) * 100
                    )
                      .toFixed(4)
                      .toLocaleString('en-US')}
                    %
                  </TableCell>

                  <TableCell style={{ color: 'grey' }} align="left">
                    {convertToInternationalCurrencySystem(
                      each.identitySymbol === 'USXM'
                        ? token.reduce((a, b) => a + b.volume, 0)
                        : volumes
                        ? volumes[each.identitySymbol] || each.volume
                        : each.volume
                    )}
                  </TableCell>

                  {/* Order Book Depth (real sum of live bids+asks for this
                      token, right now) - NOT TVL. Hootdex is a Central Limit
                      Order Book, not an AMM, so there is no per-token TVL;
                      the old amount*price notional guess here was never a
                      real financial figure. Sourced from Hootdex's own
                      markets.json (App.js's global stats poll), keyed by
                      identitySymbol. Shows "N/A" rather than a guessed
                      number when this token isn't in that data yet. */}
                  <TableCell style={{ color: 'grey' }} align="left">
                    {' '}
                    {(() => {
                      const depth = obdFor(orderBookDepth, each, href);
                      return depth !== null
                        ? convertToInternationalCurrencySystem(depth)
                        : 'N/A';
                    })()}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      color: 'grey'
                    }}
                  >
                    {' '}
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {new Date()
                        .toUTCString()
                        ?.split(' ')
                        ?.slice(0, 4)
                        .join(' ')}
                    </p>
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {new Date()?.toUTCString()?.split(' ')[4]} GMT
                    </p>
                    {/* {href === 'SynthCryptos' ? (
                  <>
                    {' '}
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {new Date().toDateString()}
                    </p>
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {new Date()?.toUTCString()?.split(' ')[4]} GMT
                    </p>
                  </>
                ) : (
                  <>
                    {' '}
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {getFormattedTime(each.timestamp).toDateString()}
                    </p>
                    <p style={{ fontSize: '12px', fontWeight: 300 }}>
                      {
                        getFormattedTime(each.timestamp)
                          ?.toUTCString()
                          ?.split(' ')[4]
                      }{' '}
                      GMT
                    </p>
                  </>
                )} */}
                  </TableCell>

                  <TableCell>
                    {swappable ? (
                      <a
                        href={`https://app.hootdex.net/${
                          each.base_symbol ? each.symbol : each.identitySymbol
                        }`}
                        target="_self"
                        rel="noreferrer"
                      >
                        <MiniCandles
                          symbol={each.identitySymbol || each.token_symbol || each.symbol}
                          chartSymbol={each?.reference_symbol || each.symbol || each.token_symbol}
                        />
                        <button
                          className={
                            currentPrice - each.price1hour < 0
                              ? 'RedSwapBtn'
                              : 'NormalSwapBtn'
                          }
                        >
                          Swap
                        </button>
                      </a>
                    ) : (
                      <MiniCandles
                        symbol={each.identitySymbol || each.token_symbol || each.symbol}
                        chartSymbol={each?.reference_symbol || each.symbol || each.token_symbol}
                      />
                    )}
                  </TableCell>
                  {isAdmin && (
                    <TableCell>
                      {/* {' '}
                  <Button
                  
                  >
                    Edit
                  </Button> */}
                      <button
                        onClick={() => {
                          setSelectedToken(each);
                          setOpen(true);
                        }}
                        className={'NormalSwapBtn'}
                      >
                        Edit
                      </button>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Skeleton
          sx={{ bgcolor: '#0b0f12', mt: 1 }}
          variant="rectangular"
          margin={'1rem'}
          height={100}
        />
      )}
      {open && (
        <ErrorBoundary
          key={selectedToken?.id ?? selectedToken?.symbol}
          onReset={() => setOpen(false)}
        >
          {selectedToken &&
          selectedToken?.type &&
          selectedToken?.type === 'DERIVATIVES' ? (
            <EditDerivativesToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
            />
          ) : selectedToken?.type === 'STNTHETICS' ? (
            <EditSyntheticToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
            />
          ) : selectedToken?.type === 'STABLECOIN' ? (
            <EditStablecoinToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
            />
          ) : selectedToken?.type === 'PDCN' ||
            selectedToken?.type === 'FDCN' ? (
            <EditDCNToken token={selectedToken} setOpen={setOpen} open={open} />
          ) : selectedToken?.type === 'wrap' ? (
            <EditWrapToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
            />
          ) : selectedToken?.type === 'dat' || selectedToken?.type === 'dbt' ? (
            <EditDBTToken token={selectedToken} setOpen={setOpen} open={open} />
          ) : selectedToken?.type === 'project' ? (
            <EditVentureToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
            />
          ) : href === 'equitrackToken' ? (
            <EditToken
              token={selectedToken}
              setOpen={setOpen}
              open={open}
              tokenType="EQUITRACK"
            />
          ) : (
            <EditToken token={selectedToken} setOpen={setOpen} open={open} />
          )}
        </ErrorBoundary>
      )}
    </TableContainer>
  );
}

export default memo(TokenTable);
